"use strict";
/**
 * @module Features.Security
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var session_property_validation_1 = require("./../../features/security/session-property-validation");
var security_1 = require("../../../features/security");
/**
 * Implementation of {@link MatchesSessionPropertyValidation}
 *
 * @inheritdoc
 */
var MatchesSessionPropertyValidationImpl = /** @class */ (function (_super) {
    __extends(MatchesSessionPropertyValidationImpl, _super);
    /**
     * Create a MatchesSessionPropertyValidationImpl instance
     *
     * @param  regex   the regular expression
     */
    function MatchesSessionPropertyValidationImpl(regex) {
        var _this = _super.call(this, security_1.ValidationType.REGEX) || this;
        _this.regex = regex;
        return _this;
    }
    /**
     * Convert object to string
     *
     * @return a string representation of the MatchesSessionPropertyValidationImpl
     */
    MatchesSessionPropertyValidationImpl.prototype.toString = function () {
        return "SessionPropertyValidation [type=" + this.type + ", regex=" + this.regex + "]";
    };
    return MatchesSessionPropertyValidationImpl;
}(session_property_validation_1.SessionPropertyValidationImpl));
exports.MatchesSessionPropertyValidationImpl = MatchesSessionPropertyValidationImpl;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/features/security/matches-property-validation.js
// module id = 1223
// module chunks = 1